<template>
	<TwoPartsTreeBlock v-on="$listeners" :isChosen="isChosen">
		<template #first-part>
			<FlowTreeActionBlock
				disabled
				:blockData="{ service: 'some-value', node_title: toolPlacement }"
				:appData="{ service_slug: toolPlacementIcon }"
				:actionData="{}"
				hideStatus
			/>
		</template>
		<template #second-part>
			<span class="text-overflow-ellipsis">
				<v-icon v-if="toolIcon" class="pr-1"> {{ toolIcon }} </v-icon>{{ toolTitle }}
			</span>
		</template>
	</TwoPartsTreeBlock>
</template>

<script>
import TwoPartsTreeBlock from './TwoPartsTreeBlock.vue';
import FlowTreeActionBlock from './FlowTreeActionBlock.vue';

export default {
	name: 'ToolPlacementTreeBlock',
	props: {
		isChosen: { type: Boolean },
		toolPlacement: { type: String },
		toolPlacementIcon: { type: String },
		toolTitle: { type: String },
		toolIcon: { type: String },
	},
	components: { TwoPartsTreeBlock, FlowTreeActionBlock },
};
</script>

<style lang="scss" scoped></style>
